import { NeosEvents } from "GesagtGetan.Basic/Resources/Private/Assets/Backend";

NeosEvents("PageLoaded,ContentModuleLoaded", _gg.onReadyRun);

NeosEvents("LayoutChanged,ContentModuleLoaded", () => {
    setTimeout(function() {
        let elements = document.querySelectorAll(".swiper-container");
        for (let i = 0; i < elements.length; i++) {
            try {
                elements[i].swiper.update(true);
            } catch (e) {}
        }
    }, 200);
});
